// extracted by mini-css-extract-plugin
export var infoItem = "_m9-1";
export var title = "_m9-0";